<template>
  <div class="maincont" id="detail_monthly_calendar">
    <div id="charts">
      <div class="ef--inner">
        <div id="monthly_calendar">
          <div id="no_print">
            <h2>月間デマンド印刷</h2>
          
            <p class="subttl">
              <a href="javascript:void(0);" id="print-btn" @click="printPage">印  刷</a>
              <span class="select-box">
                <select id="month_list" v-model="selectMonth">
                  <option
                    v-for="(month, index) in monthList"
                    v-bind:value="month.value"
                    v-bind:key="index"
                  >{{ month.text }}</option>
                </select>
              </span>
            </p>
          </div>

          <div id="monthly_calendar_legend" class="legend"></div>
          <div class="power_graph" id="power_graph-area">
            <table id="power_graph">
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "monthly_calendar",
  data: function() {
    return {
      monthlyCalendarData: {},
      selectMonth: "",
      monthList: [],
      chartList: []
    };
  },

  watch: {
    selectMonth: function(newValue) {
      this.getMonthlyCalendar(newValue);
    }
  },

  mounted: function() {
    let today = moment();
    let month = today.format("YYYY/MM");

    this.getMonthList();
    this.selectMonth = month;
  },

  methods: {
    getMonthList: function() {
      let monthList = [];
      let today = moment();
      today.subtract(36, "M").format("YYYY/MM");
      for (let index = 0; index <= 36; index++) {
        // 当月含め、過去3年間
        monthList.push({
          value: today.format("YYYY/MM"),
          text  : today.format("YYYY年MM月")
        });
        today.add(1, "M").format("YYYY/MM");
      }
      this.monthList = monthList;
    },

    getMonthlyCalendar: function(month) {
      this.$axios
        .post(
          `/srv/api/monthly_calendar/${this.$store.state.childID}`,
          { month: month },
          {
            withCredentials: true
          }
        )
        .then(response => {
          this.monthlyCalendarData = response.data;
          this.setPowerGraph();
        })
    },

    setPowerGraph: function() {
      let dateIndex = 0;
      let positionCount = 0;
      let innerHtml = "";
      let powerGraph = document.getElementById("power_graph");
      let base = this.selectMonth.split("/");
      let firstDate = new Date(Number(base[0]), Number(base[1]) - 1, 1);
      let lastDate = new Date(Number(base[0]), Number(base[1]), 1);
      lastDate.setDate(lastDate.getDate() - 1);
      positionCount = Math.ceil(((6 - lastDate.getDay()) + lastDate.getDate()) / 7) * 7;

      innerHtml += "<thead>";
      innerHtml += "<tr>";
      innerHtml += "<th style=\"width:calc(100%/7); height:25px;\">月</th>";
      innerHtml += "<th style=\"width:calc(100%/7); height:25px;\">火</th>";
      innerHtml += "<th style=\"width:calc(100%/7); height:25px;\">水</th>";
      innerHtml += "<th style=\"width:calc(100%/7); height:25px;\">木</th>";
      innerHtml += "<th style=\"width:calc(100%/7); height:25px;\">金</th>";
      innerHtml += "<th style=\"width:calc(100%/7); height:25px;\">土</th>";
      innerHtml += "<th style=\"width:calc(100%/7); height:25px;\">日</th>";
      innerHtml += "</tr>";
      innerHtml += "</thead>";

      innerHtml += "<tbody>";

      var tmpDay = firstDate.getDay();
      if (firstDate.getDay() == 0) {
        tmpDay = 7;
        positionCount = 35 + 7;
      }
      
      for (let i = 0; i < positionCount; i++) {
        if (i % 7 == 0) {
          innerHtml += "<tr>";
        }
        if ((i >= tmpDay -1) && (i <= (tmpDay - 2) + lastDate.getDate())) {
          innerHtml += "<td style=\"width:calc(100%/7); height:100px; background-color:#ffffff\">";
          dateIndex++;
          innerHtml += "<canvas id=\"power_graph_" + dateIndex + "\" width=\"\" height=\"\" style=\"display:block;\"></canvas>";
        } else {
          innerHtml += "<td style=\"width:calc(100%/7); height:100px; background-color:#bbbbbb\">";
        }
        innerHtml += "</td>";
        if (i % 7 == 6) {
          innerHtml += "</tr>";
        }
      }
      innerHtml += "</tbody>";
      powerGraph.innerHTML = innerHtml;

      let canvas;
      for (let i = 1; i <= dateIndex; i++) {  
        canvas = document.getElementById("power_graph_" + i);
        canvas.setAttribute("width", 164);
        canvas.setAttribute("height", 100);
        canvas.style.width = "164px";
        canvas.style.height = "100px";
        canvas.getContext('2d').fillStyle = 'rgb(255, 255, 255)';
        canvas.getContext('2d').fillRect(0, 0, 200, 200);
      }

      this.chartList = null;
      this.chartList = new Array(lastDate.getDate());
      let date;
      for (let i = 0; i < this.monthlyCalendarData.date_list.length; i++) {
        date = this.monthlyCalendarData.date_list[i].date.split("/");
        this.drawChart(i, Number(date[2]));
      }
    },

    drawChart: function(index, date) {
      let contact_power = [];
      let powerList = [];
      let controlPowerList = [];
      let temperatureList = [];
      let timeList = ["00:30", "01:00", "01:30", "02:00", "02:30", "03:00", "03:30", "04:00",
                      "04:30", "05:00", "05:30", "06:00", "06:30", "07:00", "07:30", "08:00",
                      "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00",
                      "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00",
                      "16:30", "17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00",
                      "20:30", "21:00", "21:30", "22:00", "22:30", "23:00", "23:30", "00:00"];

        const timeArray = Array.prototype.concat.apply(
        [],
        [...Array(25).keys()].map(v => {
          return [
            String(v).padStart(1, '0') + "時",
            String(v).padStart(1, '0') + "時30分"
          ];
        })
      );

      let minKw = this.monthlyCalendarData.demand_min;
      let maxKw = this.monthlyCalendarData.demand_max;
      let stepKw = Math.ceil(maxKw / 3);
      let minTemperature = this.monthlyCalendarData.temperature_max;
      let maxTemperature = this.monthlyCalendarData.temperature_min;
      let stepTemperature = 10;
      let airConditionerControlFlg = this.monthlyCalendarData.air_conditioner_control_flg;

      let colorSetting = document.getElementById("power_graph_" + date).getContext("2d").createLinearGradient(0, 0, 0, 380);
      colorSetting.addColorStop(0, "rgba(113, 147, 255, 1)");
      colorSetting.addColorStop(1, "rgba(193, 208, 255, 1)");

      for (let index = 0; index < 48; index++) {
        contact_power.push(this.monthlyCalendarData.contract_power);
      }

      for (let i = 0; i < timeList.length; i++) {
        if (this.monthlyCalendarData.date_list[index].time_list[i] != undefined) {
          powerList.push(Math.round( this.monthlyCalendarData.date_list[index].time_list[i].demand * Math.pow( 10, 2 ) ) / Math.pow( 10, 2 ));
          controlPowerList.push(Math.round(this.monthlyCalendarData.date_list[index].time_list[i].control_demand * Math.pow( 10, 2 ) ) / Math.pow( 10, 2 ));
          temperatureList.push(this.monthlyCalendarData.date_list[index].time_list[i].temperature);
        }
      }

      let chartData = {
        labels: [
          "00:30", "", "", "", "", "", "", "", "", "", "", "",
          "06:30", "", "", "", "", "", "", "", "", "", "", "",
          "12:30", "", "", "", "", "", "", "", "", "", "", "",
          "18:30", "", "", "", "", "", "", "", "", "", "", ""
        ],
        datasets: [
          {
            type: "line",
            label: "気温実績",
            data: temperatureList,
            borderColor: "rgba(255, 153, 0, 1.0)",
            fill: false,
            yAxisID: "y-axis-2",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0,
            borderWidth: 1
          },
          {
            type: "line",
            label: "目標電力",
            data: contact_power,
            borderColor: "rgba(0, 153, 0, 1.0)",
            fill: false,
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0,
            borderWidth: 1.2
          },
          {
            type: "bar",
            label: "デマンド実績",
            data: powerList,
            backgroundColor: colorSetting,
            hoverBackgroundColor: colorSetting,
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          
          {
            type: "bar",
            label: "抑制デマンド",
            data: controlPowerList,
            backgroundColor: "rgba(255, 0, 0, 1)",
            hoverBackgroundColor: "rgba(255, 0, 0, 1)",
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          }          
        ]
      };

      let chartOption = {
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        legendCallback: function(g) {
          var h = [];
          h.push('<ul class="' + g.id + '-legend">');
          for (var f = 1; f < g.data.datasets.length; f++) {
            if (g.data.datasets[f].label == "抑制デマンド") {
              if (airConditionerControlFlg) {
                h.push("<li><span>");
                h.push(g.data.datasets[f].label + "(kW)");
              } else {
                h.push("<li style='display:none'>");
              }
            } else {
              h.push("<li><span>");
              h.push(g.data.datasets[f].label + "(kW)");
            }
            h.push("</span></li>");
          }

          // 実績気温
          h.push("<li><span>");
          h.push(g.data.datasets[0].label + "(℃)");
          h.push("</span></li>");
          h.push("</ul>");
          return h.join("");
        },
        title: {
          display: true,
          padding: 3,
          fontSize: 11,
          fontStyle: "normal",
          text: this.monthlyCalendarData.date_list[index].date
        },
        elements: {
          line: {
            tension: 0
          },
          point: {
            radius: 0
          }
        },
        scales: {
          xAxes: [
            {
              ticks: {
                maxRotation: 0,
                minRotation: 0,
                autoSkip: false,
                padding: -7,
                fontSize: 9
              },
              gridLines: {
                display: false,
                drawOnChartArea: false
              },
              stacked: true
            }
          ],
          yAxes: [
            {
              id: "y-axis-1",
              type: "linear",
              position: "left",
              stacked: true,
              ticks: {
                min: minKw,
                max: maxKw,
                stepSize: stepKw,
                padding: -7,
                fontSize: 9
              },
            },
            {
              id: "y-axis-2",
              type: "linear",
              position: "right",
              ticks: {
                min: minTemperature,
                max: maxTemperature,
                stepSize: stepTemperature,
                padding: -7,
                fontSize: 9
              }
            }
          ]
        },
        tooltips: {
          mode:'label',
          filter: function (tooltipItem) {
            // デマンド実績、抑制デマンドのみを表示
            if (tooltipItem.datasetIndex == 2 || tooltipItem.datasetIndex == 3) {
              if (tooltipItem.value > 0) {
                return true;
              }
            }
          },
          callbacks: {
            title: function(tooltipItem) {
              return timeArray[tooltipItem[0].index+1];
            }
          }
        }
      };

      this.chartList[date - 1] = new Chart(
        document.getElementById("power_graph_" + date).getContext("2d"),
        {
          type: "bar",
          data: chartData,
          options: chartOption
        }
      );
      $("#monthly_calendar_legend").html(this.chartList[date - 1].generateLegend());
    },

    printPage: function() {
      console.log("-------- printPage");
      let headerTag = document.getElementsByTagName("header");
      let footerTag = document.getElementsByTagName("footer");
      let noPrintTag = document.getElementById("no_print");

      headerTag[0].style.display = "none";
      footerTag[0].style.display = "none";
      noPrintTag.style.display = "none";
      document.getElementById("power_graph-area").style.width = '120%';
      document.getElementById('power_graph').style.width = '50%';

      window.print();
      headerTag[0].style.display = "inline";
      footerTag[0].style.display = "inline";
      noPrintTag.style.display = "inline";
    }
  }
};
</script>
